import * as React from "react";
import { Component } from "react";
import { List, Icon, Flex } from "antd-mobile";
// const CheckboxItem = Checkbox.CheckboxItem;
const Item = List.Item;
interface IState {
	ICheck: ICheck[];
}
interface ICheck {
	label: string | number;
	value: string | number;
	isCheck: boolean;
}
interface IIndex {
	[index: number]: string | number;
}
interface IProps {
	type?: string;
	check?: IIndex;
	title?: string;
	xing?: string;
	value?: string;
	onChange?: (text: ICheck[]) => void;
}

export class FormCheckbox extends Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
	}
	readonly state: IState = {
		ICheck: [],
	};
	componentDidMount() {
		let check = this.props.check;
		let check2 = [];
		for (let index in check) {
			check2.push({ value: index, isCheck: false, label: check[Number(index)] });
		}
		this.setState({ ICheck: check2 });
	}
	_renderCheckboxItem() {
		const { ICheck } = this.state;
		return (
			<div style={{ maxWidth: "230px" }}>
				<Flex justify="start" wrap="wrap">
					{ICheck.map((item) => {
						return (
							<CheckboxItem
								name={item.label}
								key={item.value}
								onChange={() => {
									this.setState(
										{
											ICheck: this.state.ICheck.map((item) => {
												return {
													label: item.label,
													value: item.value,
													isCheck: item.value === item.value ? !item.isCheck : item.isCheck,
												};
											}),
										},
										() => {
											this.props.onChange?.(this.state.ICheck);
										}
									);
								}}
							></CheckboxItem>
						);
					})}
				</Flex>
			</div>
		);
	}
	render() {
		const { title, xing, check, onChange } = this.props;

		const { ICheck } = this.state;
		return (
			<>
				{/* <Container>
					<TitleBox>
						<Title>
							{title}
							<span style={{ color: "red" }}>{xing}</span>:
						</Title>
					</TitleBox>
					{ICheck.map((i) => (
						<CheckboxItem
							key={i.value}
							onChange={() => {
								this.setState(
									{
										ICheck: this.state.ICheck.map((item) => {
											return {
												label: item.label,
												value: item.value,
												isCheck: i.value === item.value ? !item.isCheck : item.isCheck,
											};
										}),
									},
									() => {
										onChange?.(this.state.ICheck);
									}
								);
							}}
						>
							{i.label}
						</CheckboxItem>
					))}
				</Container> */}
				<Item multipleLine extra={this._renderCheckboxItem()}>
					<span style={{ color: "red" }}>{xing}</span>
					{title}:
				</Item>
			</>
		);
	}
}

interface CheckBoxState {
	check: boolean;
}
interface CheckBoxProps {
	onChange?: (state: boolean) => void;
	name: string | number;
}

class CheckboxItem extends Component<CheckBoxProps, CheckBoxState> {
	constructor(porps: CheckBoxProps) {
		super(porps);
		this.state = {
			check: false,
		};
	}
	render() {
		const { check } = this.state;
		const { name, onChange } = this.props;
		return (
			<div
				style={{ display: "flex", alignItems: "center", marginLeft: "4px" }}
				onClick={() => {
					this.setState({ check: !check });
					onChange && onChange(check);
				}}
			>
				{check ? <Icon color="#108ee9" type="check-circle"></Icon> : <Icon type="check-circle-o"></Icon>}
				<span
					style={{
						marginLeft: "5px",
						maxWidth: "200px",
						color: "#000",
						display: "block",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
					}}
				>
					{name}
				</span>
			</div>
		);
	}
}